import React from "react";
const PatientChart = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const FacilityChart = React.lazy(() => import("../pages/Dashboard/facilityChartDashboard"));
const Home = React.lazy(() => import("../pages/Home/Home"));
const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const ReportData = React.lazy(() => import("../pages/Dashboard/ReportData"));
const Linelist = React.lazy(() => import("../pages/Dashboard/Linelist"));
const HistoricData = React.lazy(() => import("../pages/Dashboard/historic_reports"));
// const ReportData = React.lazy(() => import("../pages/ReportData/ReportData"));

const routes = [
  {
    path: "/home",
    component: Dashboard,
  },
  {
    path: "/facilityChart",
    component: FacilityChart,
  },
  {
    path: "/patientChart",
    component: Dashboard,
  },
  {
    path: "/reportdata",
    component:ReportData
  },
  {
    path: "/linelist",
    component:Linelist
  },
  {
    path: "/historicreports",
    component: HistoricData
  },
  {
    default: "/",
    path: "/",
    component: Dashboard,
  }
];

export default routes;
